import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import AppButton from "../../../ui/buttons/AppButton";
import IconButton from "../../../ui/buttons/IconButton";
import type { DocumentNavigation } from "./useDocumentNavigation";

interface DocumentNavigationControlsProps {
  navigation: DocumentNavigation;
  /** False while the document list is not available. */
  enabled: boolean;
}

export default function DocumentNavigationControls({ navigation, enabled }: DocumentNavigationControlsProps) {
  const { t } = useTranslation();
  const { previousDocument, nextDocument, randomBusy, openDocument, openRandomDocument } = navigation;

  return (
    <div className="flex items-center gap-1">
      <IconButton
        onClick={() => {
          if (previousDocument !== null) {
            openDocument(previousDocument);
          }
        }}
        disabled={!enabled || previousDocument === null}
        label={t("sources.navigation.previous")}
        title={t("sources.navigation.previous")}
        className="h-8 w-8 shrink-0"
      >
        <ArrowLeftIcon className="h-4 w-4" />
      </IconButton>
      <AppButton
        onClick={openRandomDocument}
        disabled={!enabled || randomBusy}
        variant="secondary"
        size="xs"
        className="min-w-0 flex-1 truncate font-semibold"
        title={t("sources.navigation.randomTitle")}
      >
        {randomBusy ? t("common.loading") : t("sources.navigation.random")}
      </AppButton>
      <IconButton
        onClick={() => {
          if (nextDocument !== null) {
            openDocument(nextDocument);
          }
        }}
        disabled={!enabled || nextDocument === null}
        label={t("sources.navigation.next")}
        title={t("sources.navigation.next")}
        className="h-8 w-8 shrink-0"
      >
        <ArrowRightIcon className="h-4 w-4" />
      </IconButton>
    </div>
  );
}
